import { attach, createEvent, sample } from 'effector'
import { createAction } from 'effector-action'

import { getRegisterInfo } from '@portal/client-info'
import * as lib from '@portal/lib/yahoo-oauth-popup'

import { portalProfileAPI } from '@/entities/profile/portal'
import { getPortalAPIErrorMessage } from '@/shared/api/portal/error-message'
import { env } from '@/shared/config'
import { $i18n, $lang } from '@/shared/lib/i18n'
import { toast } from '@/shared/lib/toast'
import { type NotificationArgs, showNotificationFx } from '@/shared/ui'
import { modal } from '@/shared/ui/modal'

export const yahooPairButtonClicked = createEvent()

const getAccessTokenFx = attach({ effect: lib.getAccessTokenFx })

sample({
    clock: yahooPairButtonClicked,
    source: $lang,
    fn: (lang) => ({
        lang,
        clientID: env.OAUTH_YAHOO_CLIENT_ID,
        redirectURI: lib.getRedirectURI(env.PUBLIC_URL),
    }),
    target: getAccessTokenFx,
})

const yahooPairFx = attach({ effect: portalProfileAPI.pairYahooAdd })

createAction({
    clock: getAccessTokenFx.done,
    target: { yahooPairFx },
    fn: (target, { params, result }) => {
        // popup closed or timed out
        if (!result) return

        target.yahooPairFx({
            oauth_access_code: result.code,
            register_info: getRegisterInfo(params.lang),
        })
    },
})

sample({
    clock: yahooPairFx.done,
    fn: (): NotificationArgs => ({ notification: 'account_linked_yahoo' }),
    target: [modal.closeAll, showNotificationFx],
})

sample({
    clock: yahooPairFx.fail,
    source: $i18n,
    fn: ({ i18n }, { error }) => ({ message: getPortalAPIErrorMessage(error, i18n) }),
    target: toast.errorFx,
})
